export const tr = {
    be: 'Belarusça',
    de: 'Almanca',
    en: 'İngilizce',
    kz: 'Kazakça',
    'language-not-set': 'Dil seçin',
    ru: 'Rusça',
    tr: 'Türkçe',
    ua: 'Ukraynaca',
    uz: 'Özbekçe'
};
